var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "demo-form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "200px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "提现审核提醒", prop: "description" } },
            [
              _c("el-input", {
                staticStyle: { width: "800px" },
                attrs: { placeholder: "请输入", clearable: "" },
                model: {
                  value: _vm.form.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "description", $$v)
                  },
                  expression: "form.description",
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "color_AAA" }, [
                _vm._v("当提现申请待审核时，提示用户说明文字"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "余额提现背景图", prop: "backgroundImage" } },
            [
              _c("upload", {
                attrs: {
                  name: "backgroundImage",
                  "img-url": _vm.form.backgroundImage,
                },
                on: {
                  pictureAddress: function ($event) {
                    return _vm.onPictureAddress($event)
                  },
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "color_AAA" }, [
                _vm._v("建议尺寸750px*400pX PNG图片"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "余额提现说明", prop: "imgUrl" } },
            [
              _vm.EditorOpen
                ? [
                    _c(
                      "div",
                      {
                        staticStyle: { border: "1px solid #ccc", width: "70%" },
                      },
                      [
                        _c("Toolbar", {
                          staticStyle: { "border-bottom": "1px solid #ccc" },
                          attrs: {
                            editor: _vm.editor,
                            "default-config": _vm.toolbarConfig,
                            mode: _vm.mode,
                          },
                        }),
                        _vm._v(" "),
                        _c("Editor", {
                          staticStyle: {
                            height: "300px",
                            "overflow-y": "hidden",
                          },
                          attrs: {
                            "default-config": _vm.editorConfig,
                            mode: _vm.mode,
                          },
                          on: { onCreated: _vm.onCreated },
                          model: {
                            value: _vm.form.withdrawContext,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "withdrawContext", $$v)
                            },
                            expression: "form.withdrawContext",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "color_AAA" }, [
                      _vm._v(
                        "\n          提现说明可上传图片，图片尺寸要求宽度不超过305，高度自定(宽度太大会导致图片展示不全\n        "
                      ),
                    ]),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "实名认证规则说明文档", prop: "imgUrl" } },
            [
              _vm.EditorOpen
                ? [
                    _c(
                      "div",
                      {
                        staticStyle: { border: "1px solid #ccc", width: "70%" },
                      },
                      [
                        _c("Toolbar", {
                          staticStyle: { "border-bottom": "1px solid #ccc" },
                          attrs: {
                            editor: _vm.editor,
                            "default-config": _vm.toolbarConfig,
                            mode: _vm.mode,
                          },
                        }),
                        _vm._v(" "),
                        _c("Editor", {
                          staticStyle: {
                            height: "300px",
                            "overflow-y": "hidden",
                          },
                          attrs: {
                            "default-config": _vm.editorConfig,
                            mode: _vm.mode,
                          },
                          on: { onCreated: _vm.onCreated },
                          model: {
                            value: _vm.form.realNameAuthRulesText,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "realNameAuthRulesText", $$v)
                            },
                            expression: "form.realNameAuthRulesText",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v(" 保存 ")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.handleReset } }, [
                _vm._v("重置"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }